import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import translation from 'translation';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';


const accountToolsRoutes = [
  {
    path: 'tools',
    component: NestedRouteComponent,
    children: [
      {
        path: 'gs-exporter',
        component: NestedRouteComponent,
        meta: {
          routeName: {
            segmentName: () => translation.tr('Export statistics into Google Sheet')
          },
          permissions: ['READ_EXPORT_STATISTICS']
        },
        children: [
          {
            path: '',
            name: 'gs-exporter-list',
            component: () => asyncLoadView(
              import('pages/accounts/tools/GoogleSheetsExporter/GoogleSheetsExporterListPage')),
            props: routeArgsToInt
          },
          {
            path: ':exporterId(\\d+)',
            name: 'gs-exporter-detailed',
            component: () => asyncLoadView(
              import('pages/accounts/tools/GoogleSheetsExporter/GoogleSheetsExporterDetailedPage')),
            props: routeArgsToInt
          },
          {
            path: 'create',
            name: 'gs-exporter-create',
            component: () => asyncLoadView(
              import('pages/accounts/tools/GoogleSheetsExporter/GoogleSheetsExporterDetailedPage')),
            props: routeArgsToInt
          }
        ]
      }
    ]
  }
];

export default accountToolsRoutes;
